function pad2(value: number) {
  return String(value).padStart(2, "0");
}

type DatePartKind = "date" | "datetime" | "time";

function parseDate(value?: string | null) {
  if (!value) {
    return null;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
}

function formatDateParts(date: Date, kind: DatePartKind) {
  const year = date.getFullYear();
  const month = pad2(date.getMonth() + 1);
  const day = pad2(date.getDate());
  const hours = pad2(date.getHours());
  const minutes = pad2(date.getMinutes());
  const seconds = pad2(date.getSeconds());
  if (kind === "date") {
    return `${year}-${month}-${day}`;
  }
  if (kind === "time") {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatDateDisplay(value?: string | null, emptyText = "-") {
  const parsed = parseDate(value);
  if (!parsed) {
    return emptyText;
  }
  return formatDateParts(parsed, "date");
}

export function formatDateTimeDisplay(value?: string | null, emptyText = "-") {
  const parsed = parseDate(value);
  if (!parsed) {
    return emptyText;
  }
  return formatDateParts(parsed, "datetime");
}

export function formatDate(value?: string | null, emptyText = "-") {
  return formatDateDisplay(value, emptyText);
}

export function formatDateTime(value?: string | null, emptyText = "-") {
  return formatDateTimeDisplay(value, emptyText);
}

export function formatTimeDisplay(value?: string | null, emptyText = "-") {
  const parsed = parseDate(value);
  if (!parsed) {
    return emptyText;
  }
  return formatDateParts(parsed, "time");
}

export function formatDateTimeLocalInputValue(value?: string | null) {
  const parsed = parseDate(value);
  if (!parsed) {
    return undefined;
  }
  return `${formatDateParts(parsed, "date")}T${pad2(parsed.getHours())}:${pad2(parsed.getMinutes())}`;
}

export function parseDateTimeLocalInputValue(value?: string | null) {
  const normalized = String(value ?? "").trim();
  if (!normalized) {
    return undefined;
  }
  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }
  return parsed.toISOString();
}
